// GENERAL
export const API_CONFIGURABLE = "configurables/";

// USERS MANAGEMENT
export const API_PROFILE = "accounts/users/1";
export const API_USERS = "accounts/users/";
export const API_REGISTER_USER = "accounts/register-user/";
export const API_LOGIN = "token/";
export const API_OTP_VERIFICATION = "accounts/users/verify-otp/";
export const API_OTP_REQUEST = "accounts/users/request-otp/";
export const API_RESET_PASSWORD = "password_reset/confirm/";
export const API_VERIFY_PASSWORD_RESET_TOKEN = "password_reset/validate_token/";
export const API_REQUEST_PASSWORD_RESET = "password_reset/";
export const API_ACCOUNTS_ROLES = "accounts/roles/";
export const API_ACCOUNTS_PROFILES = "accounts/profiles/";
export const API_CHANGE_PASSWORD = "accounts/users/change-password/";
export const API_FIELD_OFFICERS = "/loan-applications/field-officers/";

//LOCATION DETAILS
export const API_DISTRICTS = "all-districts/";
export const API_COUNTIES = "all-counties/";
export const API_SUB_COUNTIES = "all-sub-counties/";
export const API_PARISHES = "all-parishes/";
export const API_VILLAGES = "all-villages/";
export const API_REGIONS = "all-regions/";

export const API_DISTRICTS_PAGINATED = "districts/";
export const API_COUNTIES_PAGINATED = "counties/";
export const API_SUB_COUNTIES_PAGINATED = "sub-counties/";
export const API_PARISHES_PAGINATED = "parishes/";
export const API_VILLAGES_PAGINATED = "villages/";
export const API_REGIONS_PAGINATED = "regions/";

//STREETS APRKING API

//LOCATION DETAILS

export const API_STREETS = "all-streets/";
export const API_STREETS_PAGINATED = "streets/";

export const API_COUPON_SALES = "coupons-sales/";
export const API_COUPON_SALES_PAGINATED = "coupons-sales/";

export const API_CAR_SIZE_SLOT_MAPPING = "car-size-slot-mappings/";
export const API_CAR_SIZE_SLOT_MAPPING_PAGINATED = "car-size-slot-mappings/";

export const API_PARKINGS = "parkings/";

export const API_PARKINGS_ALL = "parkings-list/";
export const API_PARKINGS_BY_DISTRICT = "parkings-by-district/";

export const API_PARKINGS_PAGINATED = "parkings-list/";

export const API_CURRENTLY_ACTIVE_PARKINGS = "active-parked-cars/";
export const API_CURRENTLY_ACTIVE_PARKINGS_PAGINATED = "active-parked-cars/";

export const API_PARKED_CARS_SERVICES = "parked-car-services/";
export const API_PARKED_CARS_SERVICES_PAGINATED = "parked-car-services/";

export const API_SLOTS = "slots/";
export const API_SLOTS_PAGINATED = "slots/";

export const API_PARKING_RATES = "parking-rates/";
export const API_PARKING_RATES_PAGINATED = "parking-rates/";

export const API_GET_PARKING_RATE_UNDER_PARK_SIZE = "get-parking-rate/";
export const API_GET_PARKING_RATE_UNDER_PARK_SIZE_PAGINATED =
  "get-parking-rate/";

export const API_PARKED_CARS = "parked-cars/";
export const API_PARKED_CARS_PAGINATED = "parked-cars/";

//RESERVATION
export const API_BOOKINGS = "bookings/";
export const API_BOOKINGS_PAGINATED = "bookings/";

export const API_VEHICLE_CLAMPINGS = "clamping/";
export const API_VEHICLE_CLAMPINGS_PAGINATED = "clamping/";

export const API_VEHICLE_CLAMPINGS_UNCLAMP = "clamping/unclamp/";

export const API_PAYMENT_MODES = "payments/payment-modes/";
export const API_PAYMENT_MODES_PAGINATED = "payments/payment-modes/";

export const API_TELECOM_NETWORK_CODES = "network-code/";
export const API_TELECOM_NETWORK_CODES_PAGINATED = "network-code/";

export const API_PENALTY_SETTINGS = "penalties/penalty-settings/";
export const API_PENALTY_SETTINGS_PAGINATED = "penalties/penalty-settings/";

export const API_SERVICE_RATES = "service-rates/";
export const API_SERVICE_RATES_PAGINATED = "service-rates/";

export const API_SERVICE_TYPES = "service-types/";
export const API_SERVICE_TYPES_PAGINATED = "service-types/";

export const API_SERVICE_TYPES_MOBILE = "get-service-type-mobile/";

export const API_SURCHARGE_CONFIGURABLES = "penalties/surcharge-configurables/";
export const API_SURCHARGE_CONFIGURABLES_PAGINATED =
  "penalties/surcharge-configurables/";

export const API_SURCHARGES = "penalties/surcharges/";
export const API_SURCHARGES_PAGINATED = "penalties/surcharges/";

export const API_PENALTIES = "penalties/penalties/";

export const API_RECONCILIATION_ERROR_LOGS_PAGINATED =
  "reconciliation-error-logs/";

export const API_STATEMENT_LOGS_PAGINATED = "statement-logs/";

export const API_VEHICLE_TYPES = "get-vehicle-type-list/";
export const API_VEHICLE_TYPES_PAGINATED = "get-vehicle-type-list/";

export const API_VEHICLE_TYPES_CREATE = "vehicle-types/";

export const API_CAR_TYPES = "car-type/";
export const API_ALL_CAR_TYPES = "all-car-types/";
export const API_CAR_TYPES_PAGINATED = "car-type/";

export const API_BOOKING_RESERVATION_RATES = "reservations-rates/";
export const API_BOOKING_RESERVATION_RATES_PAGINATED = "reservations-rates/";

export const API_ADVANCES_BALANCE = "advances/";
export const API_ADVANCES_BALANCE_PAGINATED = "advances/";

export const API_LINKED_CARS = "advance-cars/";
export const API_LINKED_CARS_PAGINATED = "advance-cars/";

export const API_ADVANCES_TRANSACTIONS = "advance-transactions/";
export const API_ADVANCES_TRANSACTIONS_PAGINATED = "advance-transactions/";

//CONFIGURABLES
export const API_CONFIGURABLES = "configurables/";
export const API_CHARTS_OF_ACCOUNTS_ALL = "accountings/charts/all/";
export const API_SUPPLIER_CONFIGURABLES = "configurables/suppliers/";
export const API_SYSTEM_ACCOUNTS = "system-accounts-management/";
export const API_TRANSACTABLE_ACCOUNTS_DETAILS =
  "transactable-accounts-details/liquidation/";

export const API_CONFIGURABLES_BOOKING = "booking-types-configurables/";

export const API_STICKER_TYPES = "sticker-types/";

export const API_STICKERS_DOWNLOAD = "stickers/";

export const API_BOOKING_TYPE_CONFIGURABLE = "booking-types-configurables/";

export const API_LIQUIDATION_REQUESTS = "liquidation-requests/";

export const API_RECONCILIATIONS = "reconciliation/";

//Dashbaord
export const DASHBOARD_API = "reports/dashboard/";

//VALIDATE NIN
export const VALIDATE_NIN_API = `accounts/register-user/validate-nin/`;

// AUDIT ACTIVITY
export const API_AUDIT_ACTIVITY = "audits/activity/";

// OFFICES
export const API_DEPARTMENTS = "departments/";

// ORGANISATIONS
export const API_ORGANISATIONS = "organisations/";
// Accounts
export const API_LEDGERS = "interpreted-general-ledger/";

// Expenses
export const API_EXPENSES = "expenses/";

// Requisitions
export const API_REQUISITIONS = "requisitions/";

// Other Income
export const API_OTHER_INCOME = "other-incomes/";

// Payments
export const API_INVOICES = "billings/invoices/";
export const API_INVOICES_PAID = "billings/invoices-adhoc-summary/paid/";
export const API_INVOICES_PAID_ALL = "billings/invoices-adhoc-summary/all/";
export const API_DOWNLOAD_DEMAND_NOTICE = "billings/invoices/print-notice/";
export const API_DOWNLOAD_RECEIPT = "payments/payments/print-receipt/";
export const API_PRNS = "payments/prns/";
export const API_MOCK_PAYMENTS = "payments/payments/mock-invoice-payment/";
export const API_PAYMENT_REQUESTS_PAGINATED = "payments/payment-requests/";
export const API_PAID_REQUESTS_PAGINATED = "payments/payments/";
export const API_BILLING_INVOICES_PAGINATED = "billings/invoices/";

// REPORTS
export const API_REPORTS_DASHBOARD = "reports/dashboard/";
export const API_BILLINGS_INVOICE_LIST_REPORT =
  "billings/instalments/invoice-list-report/";
export const API_LOAN_BOOK_REPORT = "reports/loan-book-report/";
export const API_EXPENSES_REPORT = "reports/expenses/";
export const API_REVENUE_PERFORMANCE_EXPORT =
  "reports/revenue-performance-export/";
export const API_COUPON_SALES_EXPORT = "reports/coupon-sales-export/";
export const API_AGENT_DEFAULTERS_EXPORT = "defaulter-agents/export/";

export const API_AGENT_PERFORMANCE_REPORTS =
  "reports/agent-performance-export/";
export const API_PAYMENTS_REPORT = "reports/payments-export/";
export const API_AGING_REPORTS = "reports/debtors-aging-export/";

export const API_REVENUE_LEDGERS_EXPORT = "revenue-ledger/export/";

export const API_END_OF_DAY_REPORT = "end-of-day/export/";
export const API_REVENUE_SOURCE_PERFORMANCE_EXPORT =
  "revenue-performance/export/";
export const API_OCCUPANCY_REPORT_EXPORT =
  "reports/parking-slot-occupancy-export/";
export const API_DAILY_COLLECTIONS_REPORT_EXPORT =
  "reports/daily-collection-balances/export/";
// WAGE REPORTS
export const API_WAGES_REPORT = "reports/wages/wage-summary/";
export const API_WAGES_REPORT_EXPORT = "reports/wages/wage-summary/export/";
export const API_WAGE_CALCULATIONS_REPORT = "reports/wages/calculations/";
export const API_WAGE_CALCULATIONS_REPORT_EXPORT =
  "reports/wages/calculations/export/";
export const API_WAGE_ADVANCEMENTS_REPORT = "reports/wages/advancements/";
export const API_WAGE_ADVANCEMENTS_REPORT_EXPORT =
  "reports/wages/advancements/export/";
export const API_WEEKLY_COLLECTIONS_REPORT =
  "reports/wages/weekly-collections/";
export const API_WEEKLY_COLLECTIONS_REPORT_EXPORT =
  "reports/wages/weekly-collections/export/";

// ASSET REPORTS
export const API_ASSETS_REPORT = "reports/assets/";
export const API_ASSETS_REPORT_EXPORT = "reports/assets/export/";
export const API_ASSET_TRANSFERS_REPORT = "reports/assets/transfers/";
export const API_ASSET_TRANSFERS_REPORT_EXPORT =
  "reports/assets/transfers/export/";
export const API_ASSET_STATUS_UPDATES_REPORT = "reports/assets/status-updates/";
export const API_ASSET_STATUS_UPDATES_REPORT_EXPORT =
  "reports/assets/status-updates/export/";
export const API_ASSET_STOCK_VARIANCE_REPORT = "reports/assets/stock-variance/";
export const API_ASSET_STOCK_VARIANCE_REPORT_EXPORT =
  "reports/assets/stock-variance/export/";
// PERMISSIONS
export const API_ACCOUNTS_PERMISSIONS = "accounts/permissions/";

// BILLINGS
export const API_BILLINGS_FEES = "billings/fees/";
export const API_BILLING_INSTALMENTS = "billings/instalments/";
export const API_PAYMENTS = "payments/payments/";
export const API_PAYMENT_METHODS = "payments/payment-modes/";
export const API_PAID_REQUESTS = "payments/payments/";

// Exports
export const API_LEDGERS_EXPORT = "accountings/ledgers/excel-export/";
export const API_FINES_EXPORT = "reports/fines/";

export const API_COLLECT_PAYMENT = "payments/payment-requests/collect/";

//VEHICLE STATUS
export const API_CHECK_VEHICLE_STATUS = "check-vehicle-status/";

//ACCOUNT_SERVICES
export const API_ACCOUNT_SERVICES = "get-service-type-mobile/";

//EXPORT PARKING YARD
export const API_EXPORT_PARKING_YARD = "parking-export-csv/";

//CHECK ADAVANCE BALANCE
export const API_CHECK_ADVANCE_BALANCE = "advances/lookup/";
export const API_CLEAR_ADVANCES = "advances/clear-invoices/";

//NEGOTIATIONS
export const API_NEGOTIATIONS = "payments/negotiated-payments/";
export const API_FULL_PAYMENTS = "payments/payment-requests/full-payment/";

// QR CODES
export const API_QR_CODES = "qr-codes/";
export const API_QR_CODE_PAYMENT = "make-qrcode-payment/";

// WAGES
export const API_WAGES = "wages/configurations/";
export const API_STAFF_WAGES = "wages/weekly-collections/";
export const API_DAILY_COLLECTIONS = "wages/daily-collections/";
export const API_WEEKLY_COLLECTIONS = "wages/calculations/";
export const API_PAYABLE_WAGES = "wages/calculations/payable/";
export const API_WAGE_PAYMENTS_HISTORY = "wages/staff-pay/";
export const API_PAY_WAGES = "wages/staff-pay/pay-single/";
export const API_CALCULATE_WAGES = "wages/calculations/calculate/";
export const API_WAGES_CONFIGURATIONS = "wages/configurations/";
export const API_WAGES_BONUS = "wages/bonus-configurations/";
export const API_WEEKLY_COLLECTIONS_INDIVIDUAL =
  "wages/weekly-collections/individual/";
export const API_FIXED_WAGES = "wages/supervisor-wages/";
export const API_PAY_WEEK_CONFIGURATION = "wages/pay-week-configuration/";
export const API_WAGE_ADVANCEMENTS = "wages/advancements/";
export const API_REQUISITION = "requisition/";
export const API_PETTY_CASH_REQUISITION = "petty-cash-requisition/";
export const API_PAYMENT_INITIATION = "payment-inititaion/";
export const API_STAFF_TYPE = "staff-type/";

//USSD
export const API_USSD_LOGS = "payments/ussd-txn-log/";
export const API_USSD_STICKERS = "ussd-sticker-list/";

//REVERSAL REQUESTS
export const API_REVERSAL_REQUESTS = "reversal-requests/";

// REVERSAL HOLDINGS
export const API_REVERSAL_HOLDINGS = "reverse-transaction/";
export const API_DORMANT_ACCOUNTS = "dormant-advances/";

//NOTIFICATIONS
export const API_NOTIFICATIONS = "notifications/";

//ASSETS
export const API_ASSET_CATEGORIES = "asset-categories/";
export const API_ASSETS = "assets/";
export const API_ASSETS_EXPORT = "assets/export/";
export const API_ASSETS_DASHBOARD = "assets/dashboard/";
export const API_ASSET_TRANSFERS = "asset-transfers/";
export const API_ASSET_TRANSFERS_EXPORT = "asset-transfers/export/";
export const API_ASSET_STATUS_UPDATES = "asset-status-updates/";
export const API_ASSET_STATUS_UPDATES_EXPORT = "asset-status-updates/export/";
export const API_ASSET_STOCK_COUNTS = "asset-stock-counts/";
export const API_ASSET_STOCK_COUNTS_EXPORT = "asset-stock-counts/export/";
export const API_ASSET_DISPOSALS = "asset-disposals/";
export const API_ASSET_DISPOSALS_EXPORT = "asset-disposals/export/";

//DEPLOYMENTS
export const API_ENFORCEMENT_TEAMS = "enforcement-teams/";
export const API_ENFORCEMENT_TEAMS_AVAILABLE = "enforcement-teams/available/";
export const API_DEPLOYMENTS = "deployments/";
